'use strict';

(function ($) {
    $.agito = $.agito || {};
    $.agito.hrmPage = $.agito.hrmPage || {};

    $.agito.hrmPage.wfStartProcess = function (processName, variables, entityInstanceId) {

        $.post($.agito.baseUrl + 'Process/StartProcess', {
            processName: processName,
            variables: variables
        }, function (res) {

            if (res !== null && res.success) {
                if (res.result.WorkflowResultType === 0) { // Error

                    alert(res.message);

                }
                else if (res.result.WorkflowResultType === 1) { // Success

                    if (res.result.message) {
                        alert(res.result.message);
                    }

                    window.location.href = window.location.href;

                }
                else if (res.result.WorkflowResultType === 2) { // ShowCreationDialog

                    $.agito.hrmPage.wfOpenDialog(processName, variables, entityInstanceId);

                }
                else if (res.result.WorkflowResultType === 3) { // OpenTask

                    UrlHelpers.OpenBrowserTab($.agito.baseUrl + 'Process/OpenTask?instanceActivityTaskId=' + res.result.TaskId);

                }
                else if (res.result.WorkflowResultType === 4) { // OpenApprovalTask

                    UrlHelpers.OpenBrowserTab($.agito.baseUrl + 'Process/OpenApprovalTask?instanceActivityApprovalTaskId=' + res.result.ApprovalTaskId);

                }
            }
        });
    }

    $.agito.hrmPage.wfOpenDialog = function (processName, variables, entityInstanceId) {

        var url = $.agito.baseUrl + 'Process/CreationDialog';
        url += '?processName=' + (processName || '');
        url += '&variables=' + (variables || '');
        url += '&entityInstanceId=' + (entityInstanceId || '');

        // open dialog
        $.agito.hrmPage.loadDialog(url, function () {
            window.location.href = window.location.href;
        });
    }

    $.agito.hrmPage.wfOpenTask = function (processName) {

        var url = $.agito.baseUrl + 'Process/StartNewProcess';
        url += '?processName=' + (processName || '');

        // open dialog
        $.agito.hrmPage.loadDialog(url, null);
    }

    $.agito.hrmPage.wfSubmitTaskForEntity = function (entityId, entityInstanceId) {

        var url = $.agito.baseUrl + 'Process/SubmitTaskForEntity';

        $.post(url, {
            entityInstanceId: entityInstanceId,
            entityId: entityId
        }, function (res) {
            window.location.href = window.location.href;
        });

    }

    $.agito.hrmPage.wfCancelAbsenceRequest = function (entityId, entityInstanceIds) {
        var url = $.agito.baseUrl + 'Process/CancelProcessInstance';

        $.post(url, {
            entityInstanceId: entityInstanceIds,
            entityId: entityId,
        }, function (res) {
            window.location.href = window.location.href;
        });
        $.agito.hrmPage.wfStartProcess("CancelAbsenceRequest", JSON.stringify({ 'EntityInstanceId': '"' + entityInstanceIds + '"' }));
    }

    $.agito.hrmPage.wfAction = function (buttonId, instanceActivityTaskId, instanceActivityApprovalTaskId, submitForm, buttonBaseName) {

        if (submitForm) {
            $('#ButtonPressed').val(buttonId);

            if (buttonBaseName === 'REJECTTASK') {

                var placeholder = $.agito.hrmPage.createDialogPlaceholder();
                var $modal = $(placeholder);
                var $modalContent = $('.modal-content', $modal);

                $modalContent.empty();
                $modal.modal('show');
                var textArea = $('<textarea class="form-control" style="height:107px;"></textarea>');

                $modalContent.prepend($('<div class="modal-header"><button type="button" class="close" onclick="$.agito.dialogHelper.closeDialog($(this).closest(\'.modal\'))" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">' + $.agito.resources.getResource("WF_Reject_Head") + '</h4></div>'));
                $modalContent.append($('<div class="modal-body" style="padding-left:20px;padding-right:20px;' + (($.agito.isMobileDevice || $.agito.isMobileApp) ? '' : 'min-width:670px;') + '"></div>').append(textArea));

                var footer = $('<div class="modal-footer"><button type="button" class="btn btn-default btn-close" data-bs-dismiss="modal" style="outline:none;">' + $.agito.resources.getResource("WF_Reject_Abort") + '</button></div>');
                footer.prepend($('<button type="button" class="btn btn-primary" data-bs-dismiss="modal" style="outline:none;">' + $.agito.resources.getResource("WF_Reject_Confirm") + '</button>').click(function () {
                    $('[data-basename="Workflow_Comment"]').find('input').val(textArea.val());

                    $.agito.hrmPage.submitForm(function () {

                        var history = UrlHelpers.PopHistory();
                        if (history)
                            window.location = history.url;
                        else
                            window.location.href = $.agito.baseUrl;

                    }, true);
                }));
                $modalContent.append(footer);

                textArea.focus();

                return;
            }
            else {
                $.agito.hrmPage.submitForm(function () {
                    var history = UrlHelpers.PopHistory();
                    if (history)
                        window.location = history.url;
                    else
                        window.location.href = $.agito.baseUrl;
                });
            }
        }
        else {
            // make transition without form submit

            if (buttonBaseName === 'REJECTTASK') {

                var placeholder = $.agito.hrmPage.createDialogPlaceholder();
                var $modal = $(placeholder);
                var $modalContent = $('.modal-content', $modal);

                $modalContent.empty();
                $modal.modal('show');
                var textArea = $('<textarea class="form-control" style="height:107px;"></textarea>');

                $modalContent.prepend($('<div class="modal-header"><button type="button" class="close" onclick="$.agito.dialogHelper.closeDialog($(this).closest(\'.modal\'))" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">' + $.agito.resources.getResource("WF_Reject_Head") + '</h4></div>'));
                $modalContent.append($('<div class="modal-body" style="padding-left:20px;padding-right:20px;' + (($.agito.isMobileDevice || $.agito.isMobileApp) ? '' : 'min-width:670px;') + '"></div>').append(textArea));

                var footer = $('<div class="modal-footer"><button type="button" class="btn btn-default btn-close" data-bs-dismiss="modal" style="outline:none;">' + $.agito.resources.getResource("WF_Reject_Abort") + '</button></div>');
                footer.prepend($('<button type="button" class="btn btn-primary" data-bs-dismiss="modal" style="outline:none;">' + $.agito.resources.getResource("WF_Reject_Confirm") + '</button>').click(function () {

                    var url = $.agito.baseUrl + 'Process/SubmitTask';

                    $.post(url, {
                        instanceActivityTaskId: instanceActivityTaskId,
                        instanceActivityApprovalTaskId: instanceActivityApprovalTaskId,
                        transitionId: buttonId,
                        comment: textArea.val(),
                        buttonBaseName: buttonBaseName
                    }, function (res) {
                        var history = UrlHelpers.PopHistory();
                        if (history)
                            window.location = history.url;
                        else
                            window.location.href = $.agito.baseUrl;
                    });

                }));

                $modalContent.append(footer);

                textArea.focus();

                return;
            }
            else {

                var url = $.agito.baseUrl + 'Process/SubmitTask';

                $.post(url, {
                    instanceActivityTaskId: instanceActivityTaskId,
                    instanceActivityApprovalTaskId: instanceActivityApprovalTaskId,
                    transitionId: buttonId,
                    buttonBaseName: buttonBaseName
                }, function (res) {
                    var history = UrlHelpers.PopHistory();
                    if (history)
                        window.location = history.url;
                    else
                        window.location.href = $.agito.baseUrl;
                });
            }

        }
    }

    $.agito.hrmPage.buttonPressed = function (buttonId, successCallback) {
        // save button presseed information
        $('#ButtonPressed').val(buttonId);
        //if contains modal
        if ($('.modal-body form').length != 0) {
            var buttons = $("[id=ButtonPressed]");
            for (i = 0; i < buttons.length; i++) {
                $(buttons[i]).val(buttonId);
            }
        }

        //var closeTab = false;
        //if ($.agito.userSettings) {
        //    closeTab = $.agito.userSettings.OpenInNewTab;
        //}

        if (buttonId === 'SAVEANDCLOSE') {
            $.agito.hrmPage.submitForm(function () {
                var history = UrlHelpers.PopHistory();
                if (history)
                    window.location = history.url;
            });
        } else if (buttonId === 'CLOSE') {
            var history = UrlHelpers.PopHistory();
            if (history)
                window.location.href = history.url;

        } else if (buttonId === 'REJECTTASK') {
            
            $.agito.hrmPage.showCommentDialog($.agito.resources.getResource("WF_Reject_Head"), $.agito.resources.getResource("WF_Reject_Confirm"), $.agito.resources.getResource("WF_Reject_Abort"), buttonId, successCallback);

            return;
        } else {
            $.agito.hrmPage.submitForm(successCallback, true);
        }
    };

    /*
        Submits hrmPage form to action set in "$.agito.hrmPage.submitAction" or to default action if not set.

        On success: calls successCallback if set, otherwise reloads the form (not the page!)
    */
    $.agito.hrmPage.submitForm = function (successCallback, updateNavigationTitle, failCallback) {
        var $form = $('.modal-body form');
        if ($form.length == 0)
            $form = $('.hrm-page-body-placeholder form');

        var formValid = true;
        var formTableValues = {};

        // save iggrid tables
        $form.find('table.ui-iggrid-table').each(function () {
            var $this = $(this);

            if ($this.data('igGridUpdating')) {
                formValid = formValid && $this.igGridUpdating('findInvalid') === null;
                $this.igGridUpdating('endEdit', true, true);
            }

            // OBSOLETE: old form iggrids
            var $el = $(this).closest('.ag-form-table');

            if ($el.length === 0)
                return;

            var elementId = $el.attr('data-form-element-id');
            var getTableChangeset = $el.data('getTableChangeset');

            if (getTableChangeset) {
                var data = $el.data('getTableChangeset')();
                formTableValues[elementId] = data;
            }
        });

        $form.find('input[name="dynamicFormTables"]').val(JSON.stringify(formTableValues));

        // validate
        if (!formValid || !$form.valid()) {
            $.agito.hrmPage.focusToFirstElementWithError();
            return;
        }

        // save & reload
        // change submit action if defined so
        if ($.agito.hrmPage.submitAction)
            $form.attr('action', $.agito.hrmPage.submitAction);

        var $messages = $('.modal .hrm-page-messages-placeholder');

        if ($messages.length == 0)
            $messages = $('.hrm-page-messages-placeholder');
   
        // save
        $.ajax({
            url: $form.attr('action'),
            type: 'POST',

            data: new FormData($form[0]),
            cache: false,
            contentType: false,
            processData: false,

            success: function (data) {

                if (data.success) {
                    $.agito.hrmPage.saveScrollPosition();
                    var $placeholder = $('.hrm-page-placeholder');
                    var url = $placeholder.find('.hrm-page-body-placeholder').attr('data-current-url');
                    $form.attr('data-is-dirty', false);
                    $(window).trigger('ag.data.changed');

                    // replace current state in history (post save on create)
                    if ($placeholder.find('.hrm-page-body-placeholder').attr('data-is-new') === 'True') {

                        var el = document.createElement('a');
                        el.href = url;

                        var path = el.pathname;
                        var query = el.search;

                        if (path.length >= 'DynamicForm/Form'.length &&
                            path.substr(path.length - 'DynamicForm/Form'.length) === 'DynamicForm/Form') {
                            query = UrlHelpers.AddQueryParam(query, 'entityInstanceId', data.entityInstanceId);
                        } else {
                            path += '/' + data.entityInstanceId;
                        }

                        url = path + query;
                        if (!url.startsWith('/'))
                            url = '/' + url;

                        // replace current state in history
                        if ($.agito.hrmPage.updateHistory)
                            history.replaceState({}, '', url);
                    }

                    // call success callback or reload form
                    if (successCallback) {
                        successCallback(data, url);
                    }
                    else {
                        if (data.userMessages) {
                            var filtered = data.userMessages.filter(function (value) {
                                return value.persisted;
                            });

                            $.agito.hrmPage.activateForm(null, url, null, null, null, filtered.length > 0 ? filtered : null, true);

                        }
                        else {
                            $.agito.hrmPage.activateForm(null, url, null, null, null, null, true);
                        }
                    }

                    // set new page title (in navigation)
                    if (updateNavigationTitle === true)
                        $('.globalnavigation-collapse-lg.globalnavigation-navigationbar-breadcrumb > a > span')
                            .text(data.entityInstanceTitle);

                    // show any messages
                    $.agito.hrmPage.handleAjaxError($messages, data, true, $form);
                } else {
                    // show user messages
                    $.agito.hrmPage.handleAjaxError($messages, data, true, $form);

                    if (failCallback) 
                        failCallback(data);
                }
            }
        });
    };

    $.agito.hrmPage.onLeftNavigationClicked = function (formId, url, entityInstanceId, successHandler, requestReadOnly, isSubPage) {
        $(window).trigger('ag.form.unload', function (isDirty) {
            if (!isDirty) {
                document.dispatchEvent(new Event("ag.form.unload.reactcontrols"));
                $.agito.hrmPage.activateForm(formId, url, entityInstanceId, successHandler, requestReadOnly, null, false, isSubPage);
            }
        });
    }

    $.agito.hrmPage.buildDynamicFormUrl = function (url, formId, entityInstanceId, requestReadOnly, isSubPage) {
        // Load requested page
        if (!url)
            url = $.agito.baseUrl + 'DynamicForm/Form?formId=' + formId + '&entityInstanceId=' + entityInstanceId;

        // request readonly form
        if (requestReadOnly === true || requestReadOnly === false)
            url = UrlHelpers.AddQueryParam(url, 'requestReadOnly', requestReadOnly);

        // send currently active navigation menus to the next page
        var query = UrlHelpers.GetQuery(window.location.href);
        if (query.navigationId) {
            url = UrlHelpers.AddQueryParam(url, 'navigationId', query.navigationId);
        }

        if (isSubPage === true) {
            url = UrlHelpers.AddQueryParam(url, 'isSubPage', isSubPage);
        }

        // send current parameters to next page
        var jcParameter = $.agito.urlHelper.getParameterByName(url, '__jc');

        if ($('form.main-form input[name="Parameters"]').length > 0) {
            if (jcParameter === "") {
                url = UrlHelpers.AddQueryParam(url, '__jc', '{"Parameters": ' + $('form.main-form input[name="Parameters"]').val() + '}');
            }
            else {
                var jcParameters = JSON.parse(jcParameter);
                var parameters = JSON.parse($('form.main-form input[name="Parameters"]').val());

                if (jcParameters.parameters !== undefined) {
                    $.extend(jcParameters.parameters, parameters);
                }
                else {
                    jcParameters['Parameters'] = parameters;
                }

                url = UrlHelpers.AddQueryParam(url, '__jc', JSON.stringify(jcParameters));
            }
        }

        return url;
    }

    $.agito.hrmPage.activateForm = function (formId, url, entityInstanceId, successHandler, requestReadOnly, existingUserMessagesToShow, showSuccessMessage, isSubPage) {
        if (document.readyState !== 'complete') {
            setTimeout(() => {
                $.agito.hrmPage.activateForm(formId, url, entityInstanceId, successHandler, requestReadOnly, existingUserMessagesToShow, showSuccessMessage, isSubPage);
            }, 500);
            return;
        }
        // Load requested page
        url = $.agito.hrmPage.buildDynamicFormUrl(url, formId, entityInstanceId, requestReadOnly, isSubPage);

        $('.hrm-page-placeholder:first')
            .load(url,
                function (r, s, x) {

                    if (AjaxHelpers.HandleExpiredSession(x)) {
                        $(this).hide();
                        return;
                    }

                    // remove first div (the repeated placeholder due to ajax ...)
                    $(this).children(':first').unwrap();

                    // record this action in history
                    if ($.agito.hrmPage.updateHistory) {
                        history.pushState({}, '', url);
                        document.title = $('.hrm-page-placeholder').find('.hrm-page-body-placeholder').attr('data-title');
                    }

                    $('.dynamic_form_script_1:last').remove();
                    $('.dynamic_form_script_2:last').remove();

                    // remove toolbar if set so
                    if (!$.agito.hrmPage.displayToolbar)
                        $('.hrm-toolbar__renderroot').remove();

                    // display form
                    $('.hrm-page-placeholder').show();

                    if (typeof $.agito.hrmPage.activateFormGlobalSuccessHandler === 'function') {
                        $.agito.hrmPage.activateFormGlobalSuccessHandler();
                    }

                    if (typeof successHandler === 'function') {
                        successHandler();
                    }

                    // show user messages
                    if (existingUserMessagesToShow)
                        $.agito.hrmPage.handleAjaxError($('.hrm-page-messages-placeholder:first'), existingUserMessagesToShow, false);

                    if (showSuccessMessage) {
                        // show success message
                        const formVm = $('.hrm-page-placeholder:first').find("form");
                        formVm.data("formLoaded").then(() => formVm.data("agControl").userMessages.addSuccessMessage($.agito.resources.getResource("HRM_Save_Success")));
                    }
                });
    };

    $.agito.hrmPage.handleAjaxError = function (target, ajaxResponse, clearTarget, form) {
        let userMessagesViewModel = null;
        if (!target) {
            userMessagesViewModel = window.agApp.topDialog?.model?.userMessages ?? window.agApp.activePage?.userMessages;
        } else {
            userMessagesViewModel = $(target).data("userMessages");
        }

        if (!userMessagesViewModel) return;

        if (clearTarget !== false)
            userMessagesViewModel.clear();

        let allMessages = ajaxResponse.userMessages || ajaxResponse;
        let messages = [];

        // if possible, show messages on the controls where the error occurred
        if (allMessages?.length > 0) {
            for (let message of allMessages) {
                if (message.severity === "Error" && message.controlName && form?.data("agControls")?.[message.controlName]) {
                    const ctrl = form?.data("agControls")?.[message.controlName];

                    if (!ctrl.hidden && !$(ctrl.rootElement?.closest?.(".ag-form-element"))?.hasClass("ag-hidden")) {
                        form.validate().showErrors({ [ctrl.name]: message.message });
                        form.validate().invalid[ctrl.name] = true;
                        ctrl.focus();
                        continue;
                    }
                }

                messages.push(message);
            }
        }
        
        userMessagesViewModel.addMessages(messages);
    }

    $.agito.hrmPage.quickEditDialog = function (entityId, entityInstanceId, parentEntityAttributeId, parentEntityInstanceId, successCallbackHandler, formGroupId, parameters) {
        // construct url
        var url = $.agito.baseUrl + 'DynamicForm/Dialog';
        url += '?entityId=' + (entityId || '');
        url += '&entityInstanceId=' + (entityInstanceId || '');
        url += '&parentEntityAttributeId=' + (parentEntityAttributeId || '');
        url += '&parentEntityInstanceId=' + (parentEntityInstanceId || '');
        url += '&formGroupId=' + (formGroupId || '');

        var data = null;
        if (parameters)
            data = { parameters: parameters };

        // open dialog
        let resolveDialogLoaded;
        const resultPromise = new Promise(resolve => resolveDialogLoaded = resolve);

        $.agito.hrmPage.loadDialog(url, successCallbackHandler, resolveDialogLoaded, data);

        return resultPromise;
    };

    $.agito.hrmPage.postQuickEditDialog = function (entityId, entityInstanceId, parentEntityAttributeId, parentEntityInstanceId, successCallbackHandler, formGroupId, parameters) {
        // construct url
        var url = $.agito.baseUrl + 'DynamicForm/PostDialog';
        url += '?entityId=' + (entityId || '');
        url += '&entityInstanceId=' + (entityInstanceId || '');
        url += '&parentEntityAttributeId=' + (parentEntityAttributeId || '');
        url += '&parentEntityInstanceId=' + (parentEntityInstanceId || '');
        url += '&formGroupId=' + (formGroupId || '');

        // open dialog
        $.agito.hrmPage.loadDialog(url, successCallbackHandler, null, { parameters: parameters });
    };


    $.agito.hrmPage.openDeleteDialog = function (entityId, ids, entitiesToDelete, successHandler, conflictsHandler, formTableId, skipConfirmation, deleteFromDb) {

        // create dialog placeholder
        var placeholder = $.agito.hrmPage.createDialogPlaceholder();

        if (!skipConfirmation) {
            skipConfirmation = false;
        }

        var $modal = $(placeholder);
        var $modalContent = $('.modal-content', $modal);

        $modalContent.data('successHandler', successHandler);
        $modalContent.data('conflictsHandler', conflictsHandler);
        $modalContent.data('skipConfirmation', skipConfirmation);

        var deleteFromDb = (deleteFromDb === false || formTableId) ? 'False' : 'True';

        data = {
            entityId: entityId,
            ids: ids,
            formTableId: (formTableId) ? (formTableId + deleteFromDbString) : null,
            entitiesToDelete: entitiesToDelete,
            deleteFromDb: (formTableId) ? deleteFromDb : null
        };
        $.agito.dialogHelper.loadData(placeholder, $.agito.baseUrl + 'Application/Delete', null, null, data);
        // $.agito.dialogHelper.loadData = function (dialogSelector, url, callback, hidden, data) {
    }

    $.agito.hrmPage.openWizardSelectionDialog = function (parameters, direct) {

        var wizardIds = Object.keys(parameters);
        if (wizardIds.length === 0)
            return;

        //set history for SAVEANDCLOSE button
        //UrlHelpers.PushHistory(window.location.href);

        if (wizardIds.length === 1 && direct) {
            $.agito.hrmPage.createWizardInstance(wizardIds[0], parameters[wizardIds[0]]);
            return;
        }

        var placeholder = $.agito.hrmPage.createDialogPlaceholder();

        var $modal = $(placeholder);
        $modal.data('wizard-paramaters', parameters);

        var wizardIdsQuery = '';
        for (var index in wizardIds) {
            wizardIdsQuery += 'wizardIds[' + index + ']=' + wizardIds[index] + '&'
        }

        var url = $.agito.baseUrl + 'Wizard/LoadWizardSelectionDialog?' + wizardIdsQuery;
        $.agito.dialogHelper.loadData(placeholder, url);
    }

    $.agito.hrmPage.createWizardInstance = function (wizardId, parameters, handler) {

        var url = $.agito.baseUrl + 'Wizard/LoadWizardSelectionDialog';
        $.post(url, { wizardId: wizardId, parameters: parameters }, function (res) {
            if (typeof handler === 'function') {
                handler(res);
                return;
            }

            if (!res.success) {
                $.agito.hrmPage.handleAjaxError('.user-message-container', res);
                return;
            }

            UrlHelpers.PushHistory(window.location.href);
            UrlHelpers.OpenBrowserTab($.agito.baseUrl + 'Wizard/ExecuteStep?wizardInstanceId=' + res.entityInstanceId);
        });
    }

    $.agito.hrmPage.createDialogPlaceholder = function (customClass) {

        var $placeholder = $('<div class="modal ' + (customClass ? customClass : '') + '" tabindex="-1" role="dialog" data-bs-backdrop="static"><div class="modal-dialog" style="max-width:fit-content"><div class="modal-content"></div></div></div>');

        $placeholder.appendTo('body');
        $placeholder.uniqueId();

        return $placeholder;
    }

    $.agito.hrmPage.loadDialog = function (url, successCallbackHandler, loadCallback, data, customClass) {

        // create new div placeholder
        var placeholder = $.agito.hrmPage.createDialogPlaceholder(customClass);

        // set callback and open dialog
        placeholder.data('callback', successCallbackHandler);
        $.agito.dialogHelper.loadData(placeholder, url, loadCallback, null, data);
    }

    $.agito.hrmPage.submitDialog = function (buttonId) {

        var dialog = $(buttonId).closest('.modal');
        var formValid = true;
        var formTableValues = {};

        // save iggrid tables
        dialog.find('table.ui-iggrid-table').each(function () {
            var $this = $(this);

            if ($this.data('igGridUpdating')) {
                formValid = formValid && $this.igGridUpdating('findInvalid') === null;
                $this.igGridUpdating('endEdit', true, true);
            }

            var $el = $(this).closest('.ag-form-table');

            if ($el.length === 0)
                return;

            var elementId = $el.attr('data-form-element-id');
            var data = $el.data('getTableChangeset')();
            formTableValues[elementId] = data;
        });

        dialog.find('input[name="dynamicFormTables"]').val(JSON.stringify(formTableValues));

        // validate
        if (!formValid) {
            focusToFirstElementWithError();
            return;
        }
            

        $(buttonId).prop('disabled', true);

        // submit form and call callback function
        $.agito.dialogHelper.submitForm(dialog, false, dialog.data('callback'));
    }

    $.agito.hrmPage.Confirm = function (confirmMessageText, confirmHandler, rejectHandler) {

        // create dialog placeholder
        var placeholder = $.agito.hrmPage.createDialogPlaceholder("confirmation-dialog");

        placeholder.data('confirmHandler', confirmHandler);
        placeholder.data('rejectHandler', rejectHandler);
        placeholder.data('confirmMessageText', confirmMessageText);

        $.agito.dialogHelper.loadData(placeholder, $.agito.baseUrl + 'Application/Confirm');
    }

    $.agito.hrmPage.ConfirmUnformattedText = function (confirmMessageText, confirmHandler, rejectHandler) {

        // create dialog placeholder
        var placeholder = $.agito.hrmPage.createDialogPlaceholder("confirmation-dialog");

        placeholder.data('confirmHandler', confirmHandler);
        placeholder.data('rejectHandler', rejectHandler);
        placeholder.data('confirmMessageText', confirmMessageText);

        var callbackHandler = function ($dialog) {
            var messageText = $dialog.find('.form-group').find("p");
            messageText.html();
            messageText.html(confirmMessageText);
        }

        $.agito.dialogHelper.loadData(placeholder, $.agito.baseUrl + 'Application/Confirm', callbackHandler);
    }

    $.agito.hrmPage.CustomDialog = function (title, iconPath, message, buttons, buttonHandler) {

        // create dialog placeholder
        var placeholder = $.agito.hrmPage.createDialogPlaceholder("confirmation-dialog");

        placeholder.data('buttonHandler', buttonHandler);
        placeholder.data('rejectHandler', null);

        var uriEncodedButtons = [];

        const cancelButton = buttons.find(button => button.ID === 'Cancel');
        
        if (cancelButton) {
            const otherButtons = buttons.filter(button => button.ID !== 'Cancel');
            buttons = [cancelButton, ...otherButtons]; // move Cancel button to first place
        }

        buttons.forEach(function (button) {
            var uriEncodedButton = {};

            if (button.ID != null)
                uriEncodedButton.ID = encodeURIComponent(button.ID);

            if (button.Text != null)
                uriEncodedButton.Text = encodeURIComponent(button.Text);

            if (button.IconPath != null)
                uriEncodedButton.IconPath = encodeURIComponent(button.IconPath);

            if (button.DismissColor != null)
                uriEncodedButton.DismissColor = button.DismissColor;

            uriEncodedButtons[uriEncodedButtons.length] = uriEncodedButton;
        });

        var url = $.agito.baseUrl + 'Application/CustomDialog?__jc='
        url += JSON.stringify({
            title: encodeURIComponent(title),
            message: encodeURIComponent(message),
            iconPath: encodeURIComponent(iconPath),
            buttons: uriEncodedButtons
        });


        $.agito.dialogHelper.loadData(placeholder, url);
    }

    $.agito.hrmPage.CustomDialog2 = function (title, iconPath, message, buttons, buttonHandler) {
        // todo rewrite to js only
        // create dialog placeholder
        var placeholder = $.agito.hrmPage.createDialogPlaceholder("confirmation-dialog");

        placeholder.data('buttonHandler', buttonHandler);
        placeholder.data('rejectHandler', null);
        placeholder.data('autohide', false);

        const cancelButton = buttons.find(button => button.ID === 'Cancel');

        if (cancelButton) {
            const otherButtons = buttons.filter(button => button.ID !== 'Cancel');
            buttons = [cancelButton, ...otherButtons]; // move Cancel button to first place
        }

        var uriEncodedButtons = [];

        buttons.forEach(function (button) {
            var uriEncodedButton = {};

            if (button.ID != null)
                uriEncodedButton.ID = encodeURIComponent(button.ID);

            if (button.Text != null)
                uriEncodedButton.Text = encodeURIComponent(button.Text);

            if (button.IconPath != null)
                uriEncodedButton.IconPath = encodeURIComponent(button.IconPath);

            if (button.DismissColor != null)
                uriEncodedButton.DismissColor = button.DismissColor;

            uriEncodedButtons[uriEncodedButtons.length] = uriEncodedButton;
        });

        var url = $.agito.baseUrl + 'Application/CustomDialog?__jc='
        url += JSON.stringify({
            title: encodeURIComponent(title),
            message: encodeURIComponent(message),
            iconPath: encodeURIComponent(iconPath),
            buttons: uriEncodedButtons
        });
        
        $.agito.dialogHelper.loadData(placeholder, url);

        return placeholder;
    }


    /*
        Which submit action is to be used for form submit.
        If submit action is null, then default is used.
    */
    $.agito.hrmPage.submitAction = null;

    /*
        Before custom success handler is executed,
        execute global success handler. (optional)
    */
    $.agito.hrmPage.activateFormGlobalSuccessHandler = null;

    /*
        Indicates whether toolbar of loaded form(s) is to be displayed.
    */
    $.agito.hrmPage.displayToolbar = true;

    /*
        Indicates whether history will be updated with each click in navigation.
    */
    $.agito.hrmPage.updateHistory = true;

    $.agito.hrmPage.hideSection = function () {
        var $this = $(this);
        var section = $this.closest('.dynamic-form-section');
        var header = section.prev();
        header.find('.dynamic-form-section-header-text').text($this.text());

        section.addClass('ag-hidden');
        header.removeClass('ag-hidden');
    }

    $.agito.hrmPage.showSection = function () {
        var $this = $(this);
        var sectionHeader = $this.closest('.dynamic-form-section-header');
        var section = sectionHeader.next();

        sectionHeader.addClass('ag-hidden');
        section.removeClass('ag-hidden');

        section.trigger('shown');
    }

    $.agito.hrmPage.saveScrollPosition = function () {
        if (window.scrollY) {
            const scrollerPosition = window.scrollY;
            if (scrollerPosition) {
                window.savedScrollPosition = null;
                window.savedScrollPosition =  JSON.stringify(scrollerPosition);
            }
        }
    }

    $.agito.hrmPage.restoreLastScrollPagePosition = function () {
        let scrollPositionFromStorage = window.savedScrollPosition;
        if (scrollPositionFromStorage) {

            window.savedScrollPosition = null;

            let parseScrollPosition = JSON.parse(scrollPositionFromStorage);
            if (parseScrollPosition == null) {
                return false;
            }

            // scroll to last position, but keep retrying for up to 300ms, as the page might not be fully loaded yet
            (function scrollIntoPosition(position, duration) {
                if (window.scrollY < parseScrollPosition && duration >= 0) {
                    window.scrollTo({ top: position, behavior: "smooth" });

                    setTimeout(() => scrollIntoPosition(position, duration - 10), 10);
                }
            })(parseScrollPosition, 300);
        }
    }

    $.agito.hrmPage.focusToFirstElementWithError = function () {

        var errorElements = document.getElementsByClassName("has-error");

        if (errorElements.length > 0) {
            var target = errorElements[0];

            if (target.closest('.modal-dialog')) {
                target.scrollIntoView(true);
                return;
            }

            var nav = document.querySelector('.hrm-navigation__root');
            var toolbar = document.querySelector('.hrm-toolbar__sticky');

            var navHeight = nav ? nav.offsetHeight : 0;
            var toolbarHeight = toolbar ? toolbar.offsetHeight : 0;
            const labelHeight = 30;

            var totalOffset = navHeight + toolbarHeight;

            var y = target.getBoundingClientRect().top + window.scrollY - totalOffset - labelHeight;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    }


})($);

var Agitavit = Agitavit || {};
Agitavit.DynamicForm = Agitavit.DynamicForm || {};

Agitavit.DynamicForm.GenerateDocument = function ($form) {

    var entityId = $form.find('input[name="EntityId"]').val();
    var entityInstanceId = $form.find('input[name="EntityInstanceId"]').val();

    $.agito.hrmPage.loadDialog($.agito.baseUrl + 'Administration/DocumentTemplates/SelectDocumentTemplateDialog?entityId=' + entityId + '&entityInstanceId=' + entityInstanceId);
}

Agitavit.DynamicForm.ShowHistory = function ($form) {

    var entityInstanceId = $form.find('input[name="EntityInstanceId"]').val();
    var formId = $form.find('input[name="formId"],input[name="FormId"]').val();

    var url = $.agito.baseUrl + 'History/List?formId=' + formId + '&entityInstanceId=' + entityInstanceId;

    if ($('form.main-form input[name="Parameters"]').length > 0) {
        url = UrlHelpers.AddQueryParam(url, '__jc', '{"Parameters": ' + $('form.main-form input[name="Parameters"]').val() + '}');
    }
    // dialog
    $.agito.hrmPage.loadDialog(url);
}

Agitavit.DynamicForm.EditForm = function ($form) {

    var formId = $form.find('input[name="formId"],input[name="FormId"]').last().val();
    var url = $.agito.baseUrl + 'Administration/Form/EditForm/' + formId;
    UrlHelpers.OpenBrowserTab(url, true);

}